export const emptyFn = () => void 0
